import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import type { CourseLesson } from "src/components/Course/lessons/Lesson/RepetitionLesson";
import DefaultDetails, {
	DefaultScore,
} from "src/components/NewComponents/Views/Details/DefaultDetails";
import ExamProgress from "src/components/NewComponents/Views/Progresses/ExamProgress";
import isMobile from "src/helpers/isMobile";

interface InProgressDetailsProps {
	lesson: CourseLesson;
	className?: string;
	Score?: ReactNode;
}

export default function InProgressDetails({
	lesson,
	className,
	Score = null,
}: InProgressDetailsProps) {
	const { t } = useTranslation();
	const title = isMobile()
		? t("defaultsText.score")
		: t("defaultsText.yoursScore");

	return (
		<DefaultDetails
			className={className}
			title={lesson.name}
			Score={() => (
				<div className="flex gap-8">
					<DefaultScore
						className=""
						title={`${title}: ${lesson.exam.score}%`}
					/>
					{Score}
				</div>
			)}
			Progress={() => <ExamProgress row={lesson.exam} />}
		/>
	);
}
